import { BRAND } from "@/data/content";

const RiskDisclosure = ({ dark = false }) => (
  <div
    data-testid="risk-disclosure"
    className={`rounded-sm border p-6 lg:p-8 ${dark ? "border-coalline bg-coalsurf" : "border-line bg-subtle"}`}
  >
    <p className={dark ? "eyebrow-dark" : "eyebrow"}>Risk Disclosure</p>
    <p className={`mt-4 text-xs sm:text-sm leading-relaxed ${dark ? "text-[#A0A09C]" : "text-dim"}`}>{BRAND.riskDisclosure}</p>
  </div>
);

export default RiskDisclosure;
